/** Must match STRIPE_PLATFORM_FEE_PERCENT on the server (default 5). */
export const PLATFORM_FEE_RATE = 0.05;

export const vendorEarningsFromTotal = (total: number) =>
  Number((total * (1 - PLATFORM_FEE_RATE)).toFixed(2));
